/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Marwa Khalil Ferah',
        title: 'Abonnée (Facebook)',
        text: "Bonjour Dr et merci pour les conseils",
        image: girl2
    },
    {
        id: 2,
        name: 'Fany Sidaoui',
        title: 'Abonné (Facebook)',
        text: "nous comptons sur vous pour continuer à nous prodiguer tous vos bons conseils.",
        image: boy2
    },
    {
        id: 3,
        name: 'Sara Riahi',
        title: 'Abonnée (Facebook)',
        text: "Vous êtes digne de respect et de confiance 🌟 Avec votre clarté, votre sincérité qu'on lit sur votre visage et à travers vos paroles... avec ce joyeux et lumineux visage... ce sourire suave... Tout cela rend de vous une personne attachante et digne d'attention 🎉🌸🎈 Rien ne se donne gratuitement.",
        image: girl2
    },
    {
        id: 4,
        name: 'Sonia Ayari',
        title: 'Abonnée (Facebook)',
        text: "Merci pour tes conseils précieux",
        image: girl3
    },
    {
        id: 5,
        name: 'Gabemu',
        title: 'Abonné (Tiktok)',
        text: 'Merci pour ce que vous faites Dr',
        image: boy2
    },
    {
        id: 6,
        name: 'Faouzia Saidi',
        title: 'Abonné (Tiktok)',
        text: "Merci bien pour les conseils",
        image: girl1
    }
]

